const TICK_INTERVAL = 1000;
const GAP_HISTORY_SIZE = 20;

export class SleepDetector {
	private lastTickAt = Date.now();
	private gaps: number[] = [];
	private sentinel?: ReturnType<typeof setInterval>;

	start(): void {
		if (this.sentinel) {
			return;
		}
		this.reset();
		this.sentinel = setInterval(this.tick, TICK_INTERVAL);
	}

	stop(): void {
		if (this.sentinel) {
			clearInterval(this.sentinel);
			this.sentinel = undefined;
		}
	}

	reset(): void {
		this.gaps = [];
		this.lastTickAt = Date.now();
	}

	getSleepDuration(): number {
		return this.gaps.length ? Math.max(...this.gaps) : 0;
	}

	private tick = () => {
		const now = Date.now();
		this.gaps.push(now - this.lastTickAt);
		if (this.gaps.length > GAP_HISTORY_SIZE) {
			this.gaps.shift();
		}
		this.lastTickAt = now;
	};
}
